<div
  #categoryModal
  class="modal fade"
  id="categoryModal"
  tabindex="-1"
  aria-labelledby="categoryModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="categoryModalLabel">{{ title }}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" [attr.aria-label]="'common.close' | translate"></button>
      </div>
      <div class="modal-body">
        <form #categoryForm="ngForm" novalidate>
          <!-- Category Name -->
          <div class="mb-3">
            <label for="categoryName" class="form-label">{{ 'store.categories.table.name' | translate }}</label>
            <input
              type="text"
              class="form-control"
              id="categoryName"
              [(ngModel)]="category.name"
              name="categoryName"
              #categoryName="ngModel"
              required
            />
            <!-- Error Message -->
            <div *ngIf="categoryName.invalid && categoryName.touched" class="text-danger">
              {{ 'store.categories.nameRequired' | translate }}
            </div>
          </div>

          <!-- Category Arabic Name -->
          <div class="mb-3">
            <label for="categoryArabicName" class="form-label">{{ 'store.categories.table.nameAr' | translate }}</label>
            <input
              type="text"
              class="form-control"
              id="categoryArabicName"
              [(ngModel)]="category.nameAr"
              name="categoryArabicName"
              #categoryArabicName="ngModel"
              required
            />
            <!-- Error Message -->
            <div *ngIf="categoryArabicName.invalid && categoryArabicName.touched" class="text-danger">
              {{ 'store.categories.nameArRequired' | translate }}
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-bs-dismiss="modal">{{ 'common.cancel' | translate }}</button>
        <button type="button" class="btn btn-success" (click)="save(categoryForm)">{{ 'common.save' | translate }}</button>
      </div>
    </div>
  </div>
</div>
